<template>
  <transition name="fade">
    <!-- popup background -->
    <div v-if="isVisible" class="container-fluid">
      <div class="bb-popup-bg justify-content-center align-items-center">
        <!-- popup box -->
        <div class="card bb-card shadow mb-2 rounded" style="
            width: 60rem;
            z-index: 999999 !important;
            position: relative !important;
          ">
          <slot></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "PopUpModalStrip",

  data: () => ({
    isVisible: false,
  }),

  methods: {
    async open() {
      return new Promise((resolve) => {
        this.isVisible = true;
        resolve();
      });
    },

    close() {
      this.isVisible = false;
    },
  },
};
</script>